import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-41ab1d3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "exception-body",
  style: `background-image: url('/bg-404.jpg')`
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/locaa.png",
  alt: "diamond-layout",
  class: "logo",
  style: {"width":"200px"}
}, null, -1))
const _hoisted_3 = { class: "exception-content" }
const _hoisted_4 = { class: "exception-title" }
const _hoisted_5 = { class: "exception-detail" }

import { getFirstReadAccess } from "@/utils/activity";


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorPage',
  setup(__props) {

const accessUrl = `/workspace/${getFirstReadAccess()}`;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("exceptionTitle")), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("exceptionDetail")), 1),
      _createVNode(_component_router_link, { to: accessUrl }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("goToDashboard")), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})